// Mock data for La Saponaria - Cosmetici Naturali e Biologici

// Sedi reali La Saponaria
export const laSaponariaLocations = [
  'Ancona',
  'Bastia Umbra',
  'Battipaglia',
  'Bologna',
  'Civitanova',
  'Fano',
  'Milano Centro',
  'Milano Solari',
  'Modena',
  'Montebelluna',
  'Parma',
  'Pescara',
  'Ravenna',
  'Rimini',
  'Roma Cola di Rienzo',
  'Roma Bergamo',
  'Sassari',
  'Senigallia',
  'Viareggio',
  'Pesaro (Sede)',
]

// Mock data for dashboard visualizations
export const connectionData = [
  { name: 'Lun', connections: 420 },
  { name: 'Mar', connections: 380 },
  { name: 'Mer', connections: 550 },
  { name: 'Gio', connections: 490 },
  { name: 'Ven', connections: 600 },
  { name: 'Sab', connections: 450 },
  { name: 'Dom', connections: 380 },
]

export const topicData = [
  { name: 'Viso', value: 35, color: '#1a4d2e' },
  { name: 'Capelli', value: 28, color: '#2d7a4f' },
  { name: 'Corpo', value: 22, color: '#4aa770' },
  { name: 'Solidi', value: 10, color: '#7bc99c' },
  { name: 'Altro', value: 5, color: '#a8d5ba' },
]

export const collaborationData = [
  { name: 'Milano Centro', collaborations: 245 },
  { name: 'Roma Cola di Rienzo', collaborations: 198 },
  { name: 'Bologna', collaborations: 173 },
  { name: 'Firenze', collaborations: 156 },
  { name: 'Torino', collaborations: 142 },
  { name: 'Napoli', collaborations: 134 },
  { name: 'Pesaro', collaborations: 120 },
]

export const locationData = [
  {
    id: 1,
    name: 'Milano Centro',
    connections: 2450,
    collaborations: 245,
    activeUsers: 560,
  },
  {
    id: 2,
    name: 'Roma Cola di Rienzo',
    connections: 1980,
    collaborations: 198,
    activeUsers: 430,
  },
  {
    id: 3,
    name: 'Bologna',
    connections: 1730,
    collaborations: 173,
    activeUsers: 380,
  },
  {
    id: 4,
    name: 'Milano Solari',
    connections: 1560,
    collaborations: 156,
    activeUsers: 320,
  },
  {
    id: 5,
    name: 'Pesaro',
    connections: 1420,
    collaborations: 142,
    activeUsers: 290,
  },
]

// New data for Community Impact Index
export const impactIndexData = [
  { range: '0-10', count: 12, average: 5.8 },
  { range: '11-20', count: 28, average: 16.3 },
  { range: '21-30', count: 45, average: 25.7 },
  { range: '31-40', count: 60, average: 35.4 },
  { range: '41-50', count: 48, average: 45.9 },
  { range: '51-60', count: 32, average: 55.2 },
  { range: '61-70', count: 22, average: 65.6 },
  { range: '71-80', count: 15, average: 75.1 },
  { range: '81-90', count: 8, average: 85.3 },
  { range: '91-100', count: 3, average: 93.7 },
]

export const impactIndexByLocation = {
  'Milano Centro': { average: 58.2, distribution: [...impactIndexData] },
  'Roma Cola di Rienzo': {
    average: 52.7,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 0.9),
      })),
    ],
  },
  Bologna: {
    average: 49.5,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 0.85),
      })),
    ],
  },
  'Milano Solari': {
    average: 55.1,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 0.88),
      })),
    ],
  },
  Pesaro: {
    average: 60.3,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 0.95),
      })),
    ],
  },
  'Tutte le Sedi': { average: 55.2, distribution: [...impactIndexData] },
}

export const impactIndexByTopic = {
  Viso: {
    average: 61.4,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 1.1),
      })),
    ],
  },
  Capelli: {
    average: 57.8,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 1.05),
      })),
    ],
  },
  Corpo: {
    average: 52.3,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 0.95),
      })),
    ],
  },
  Solidi: {
    average: 48.9,
    distribution: [
      ...impactIndexData.map((d) => ({
        ...d,
        count: Math.floor(d.count * 0.85),
      })),
    ],
  },
  'Tutte le Categorie': { average: 55.2, distribution: [...impactIndexData] },
}

// Mock data for rewards and redemptions - Prodotti La Saponaria
// Date range: 15 Dicembre 2025 - 7 Gennaio 2026
export const redemptionsOverTime = [
  { date: '15 Dic', redemptions: 45 },
  { date: '20 Dic', redemptions: 52 },
  { date: '25 Dic', redemptions: 61 },
  { date: '30 Dic', redemptions: 58 },
  { date: '2 Gen', redemptions: 73 },
  { date: '5 Gen', redemptions: 68 },
  { date: '7 Gen', redemptions: 82 },
]

export const redemptionsByType = [
  {
    type: 'Prodotti Viso',
    count: 156,
    image:
      'https://blog.lasaponaria.it/hubfs/Imported_Blog_Media/crema-viso-deep-care-anti-age-50-ml-la-saponaria.jpg',
  },
  {
    type: 'Cosmetici Solidi',
    count: 98,
    image:
      'https://blog.lasaponaria.it/hubfs/Imported_Blog_Media/shampoo-solido-capelli-grassi-con-argilla-verde-100-gr-la-saponaria.jpg',
  },
  {
    type: 'Prodotti Capelli',
    count: 87,
    image:
      'https://blog.lasaponaria.it/hubfs/Imported_Blog_Media/henne-tinta-vegetale-castano-scuro-100-gr-la-saponaria.jpg',
  },
  {
    type: 'Esperienze',
    count: 64,
    image: 'https://blog.lasaponaria.it/hubfs/workshop-cosmetici-naturali.jpg',
  },
]

export const topRewards = [
  {
    id: 1,
    name: 'Siero Acido Ialuronico Multi-Peso',
    status: 'Attivo',
    redemptions: 234,
    diamondsSpent: 11700,
    lastRedemption: '2 ore fa',
    category: 'Prodotti Viso',
    availability: 45,
    totalAvailability: 100,
  },
  {
    id: 2,
    name: 'Kit Cosmetici Solidi Zero Waste',
    status: 'Attivo',
    redemptions: 187,
    diamondsSpent: 9350,
    lastRedemption: '5 ore fa',
    category: 'Cosmetici Solidi',
    availability: 12,
    totalAvailability: 50,
  },
  {
    id: 3,
    name: 'Crema Viso Deep Care Anti-Age',
    status: 'Attivo',
    redemptions: 156,
    diamondsSpent: 7800,
    lastRedemption: '1 giorno fa',
    category: 'Prodotti Viso',
    availability: 28,
    totalAvailability: 80,
  },
  {
    id: 4,
    name: 'Set Hennetica Tinte Vegetali',
    status: 'Attivo',
    redemptions: 142,
    diamondsSpent: 8520,
    lastRedemption: '3 ore fa',
    category: 'Prodotti Capelli',
    availability: 23,
    totalAvailability: 60,
  },
  {
    id: 5,
    name: 'Workshop Cosmetici Fai-da-Te',
    status: 'Attivo',
    redemptions: 98,
    diamondsSpent: 9800,
    lastRedemption: '1 giorno fa',
    category: 'Esperienze',
    availability: 5,
    totalAvailability: 20,
  },
]

export const actionItems = [
  {
    id: 2,
    type: 'expiring',
    title: '3 premi in scadenza',
    link: '/rewards?filter=expiring',
    priority: 'medium',
  },
  {
    id: 3,
    type: 'lowStock',
    title: '5 premi con disponibilità bassa',
    link: '/rewards?filter=lowStock',
    priority: 'medium',
  },
]
